// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.react-select__control {
  width: 100% !important;
}

.modal-body {
  padding: 20px;
}

button.btn-outline-primary {
  width: 100%;
  margin-top: 10px;
}

.form-control.is-invalid {
  border-color: #dc3545;
}

.form-control.is-invalid:focus {
  box-shadow: none;
}`, "",{"version":3,"sources":["webpack://./src/components/DietPlanModal/DietPlanModal.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":[".react-select__control {\n  width: 100% !important;\n}\n\n.modal-body {\n  padding: 20px;\n}\n\nbutton.btn-outline-primary {\n  width: 100%;\n  margin-top: 10px;\n}\n\n.form-control.is-invalid {\n  border-color: #dc3545;\n}\n\n.form-control.is-invalid:focus {\n  box-shadow: none;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
